import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import lottie from 'lottie-web';

const init = () => {
  gsap.registerPlugin(CustomEase);

  const headerLogo = document.querySelector('.js-headerLogo');
  const headerGnav = document.querySelector('.js-headerGnav');
  const headerToggle = document.querySelector('.js-headerToggle');
  const container = document.querySelector('.js-container');

  const mvOverlay = document.querySelector('.js-mvOverlay');
  const splashSakura = document.querySelector('.js-splashSakura');
  const splashShinkansen = document.querySelector('.js-splashShinkansen');
  const splashCatch = document.querySelector('.js-splashCatch');
  const mvFrame = document.querySelector('.js-mvFrame');
  const mvSlider = document.querySelector('.js-mvSlider');

  let splashTl = gsap.timeline({paused: true});
  CustomEase.create("customSpring", "M0,0 C0.24,0.01 0.18,0.93 1,1");

  splashTl.to(mvOverlay, {
    autoAlpha: 0,
    duration: 0.5,
    ease: 'customSpring'
  });
  splashTl.to(splashSakura, {
    autoAlpha: 1,
    scale: 1,
    duration: 0.7,
    ease: 'customSpring'
  }, '-=0.45');
  splashTl.to(splashShinkansen, {
    scale: 1,
    duration: 0.7,
    ease: 'customSpring'
  }, '-=0.7');
  splashTl.to(mvFrame, {
    clipPath: 'inset(0 0% 0 0)',
    duration: 0.6,
    ease: 'power1.out',
  }, '-=0.7');
  splashTl.to(mvSlider, {
    scale: 1,
    y: 0,
    duration: 0.7,
    ease: 'power1.out',
    onComplete: () => {
      slider(mvSlider);
    }
  }, '-=0.7');
  splashTl.to(headerLogo, {
    autoAlpha: 1,
    y: 0,
    duration: 0.7,
    ease: 'customSpring'
  }, '-=0.7');
  splashTl.to(headerGnav, {
    autoAlpha: 1,
    y: 0,
    duration: 0.7,
    ease: 'customSpring'
  }, '-=0.7');
  splashTl.to(headerToggle, {
    autoAlpha: 1,
    y: 0,
    duration: 0.7,
    ease: 'customSpring'
  }, '-=0.7');
  splashTl.to(splashCatch, {
    autoAlpha: 1,
    duration: 0.5,
    ease: 'power1.out',
    onComplete: () => {
      container.classList.add('is-splashFinished');
    }
  }, '+=0.1');

  window.addEventListener('load', () => {
    splashTl.play();
  });

  const sakuraAnimation = (elm) => {
    lottie.loadAnimation({
      container: elm,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'assets/attachment/sakura-animation.json'
    });
  }
  sakuraAnimation(splashSakura);

  const slider = (parent) => {
    const mvSliderItems = parent.querySelectorAll('.js-mvSliderItem');
    let maxIndex = mvSliderItems.length - 1;
    let currentIndex = 0;
    let nextIndex = 1;

    setInterval(() => {
      nextIndex = (currentIndex === maxIndex) ? 0 : currentIndex + 1;
      mvSliderItems[nextIndex].classList.add('is-animating');
      mvSliderItems[nextIndex].classList.add('is-active');

      setTimeout(() => {
        mvSliderItems[currentIndex].classList.remove('is-active');
        mvSliderItems[nextIndex].classList.remove('is-animating');
        currentIndex = nextIndex;
      }, 600);
    }, 3000);
  }
}

export {
  init
}
